package com.futurions.portfolio.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyItems
import com.varabyte.kobweb.compose.css.MixBlendMode
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import org.jetbrains.compose.web.css.percent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun Projects() {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .id("projects")
            .padding(topBottom = 80.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        //  Spacer(modifier = Modifier.height(40.px))
        SpanText(
            text = "🚀 Projects",
            modifier = Modifier
                .fontSize(32.px)
                .fontWeight(FontWeight.Bold)
                .padding(bottom = 30.px)
                .color(Color.white)
        )

        SimpleGrid(
            modifier = Modifier
                .gap(32.px)
                .maxWidth(1000.px)
                .margin(top = 20.px, bottom = 40.px)
                .fillMaxWidth(), // ensure it fills the max width
            numColumns = numColumns(
                base = 1,
                md = 2
            ) // 1 column on small screens, 2 on medium/large
        ) {
            val projects = listOf(
                Project(
                    "NutriSport",
                    "A multiplatform fitness & e-commerce app with Google Sign-In, Firebase & Supabase storage.",
                    "/images/nutri_sport.png",
                    "https://github.com/gauravsingh2906/NutritionSports.git",
                    icons = listOf(
                        "/tools/Android.png",
                        "/tools/compose1.png",
                        "/tools/firebase.png",
                        "/tools/figma_1.png"
                    ),
                    features = listOf(
                        "Dependency Injection - Koin",
                        "Multi-Module Clean Architecture (MVVM + KMM)",
                        "Firebase Auth & Supabase integration for storage and product management",
                    )
                ),
                Project(
                    "Math Mingle",
                    "A brain-boosting app designed to level up users math speed and memory skills.",
                    "/images/kobweb_math_mingle.png",
                    icons = listOf(
                        "/tools/Android.png",
                        "/tools/compose1.png",
                        "/tools/figma_1.png"
                    ),
                    features = listOf(
                        "Clean Architecture + MVVM with Dagger Hilt",
                        "Offline-ready data handling using Room + Flow",
                        "Multiple game modes including Sudoku, quick-math drills, and memory tests"
                    ),
                    playStoreLink = "https://play.google.com/store/apps/details?id=com.futurion.apps.mindmingle"
                ),
                Project(
                    "QuizTime",
                    "A programming-focused quiz app that helps users level up their coding skills.",
                    "/images/quiz_special.png",
                    icons = listOf(
                        "/tools/intelliJ.svg",
                        "/tools/Android.png",
                        "/tools/compose1.png",
                    ),
                    features = listOf(
                        "Custom-built backend using Ktor + MongoDB, deployed on Railway",
                        "Clean Architecture + MVVM with offline caching via Room + Flow",
                        "Custom HTTP client for complete control over API handling"
                    )
                ),
                Project(
                    "Image Vista",
                    "A modern Android app to explore, search, and save beautiful photos from the Unsplash API. Users can download, share, and set wallpapers easily.",
                    "/images/kobweb_vista.png",
                    icons = listOf(
                        "/tools/Android.png",
                        "/tools/compose1.png",
                        "/tools/firebase.png",
                        "/tools/figma_1.png"
                    ),
                    features = listOf(
                        "Paging 3 with Flow + LiveData for seamless image loading",
                        "Clean Architecture + MVVM with Room caching",
                        "Dagger Hilt for structured and scalable DI"
                    )
                ),
                Project(
                    "Mario Platformer",
                    "A 2D Mario-style platformer built in Godot using custom sprites and animations",
                    "/images/godot_mario.png",
                    features = listOf(
                        "Built with Godot Engine using GDScript",
                        "Custom animations + sprite handling for player movement",
                        "Hand-crafted level design with enemy and obstacle logic"
                    ),
                    icons = listOf(
                        "/tools/gd_script.png"
                    ),
                ),
                Project(
                    "Castle Adventure",
                    "Castle Environment game made using Unreal Engine 5 Blueprints",
                    "/images/unreal_castle.png",
                    features = listOf(
                        "Built entirely with Blueprint Visual Scripting",
                        "Detailed environment design with custom landscapes and castle areas",
                        "Interactive UI + basic player controls for exploring the world"
                    ),
                    icons = listOf(
                        "https://www.citypng.com/public/uploads/preview/hd-unreal-engine-white-logo-icon-png-7017516949697958pnkct2kiz.png"
                    ),
                ),
                Project(
                    "Whiteboard",
                    "A multiplatform whiteboard app for Android and Web using Kotlin",
                    "/images/whiteboard.png",
                    features = listOf(
                        "Clean Architecture + MVVM with Flow-based onAction + event handling",
                        "Room + DataStore for synced storage across features",
                        "Multiplatform setup using Koin DI with shared modules for repositories & ViewModels"
                    ),
                    icons = listOf(
                        "/tools/Android.png",
                        "/tools/compose1.png",
                        "/tools/kotlin.png",

                    )
                ),
                Project(
                    "Shree Bhagawad Gita",
                    "A spiritual learning app built with Kotlin + XML, offering Gita chapters in Hindi and English",
                    "/images/gita_kotlin.png",
                    icons = listOf(
                        "/tools/Android.png",
                        "/tools/kotlin.png",
                        "/tools/kobweb_xml.png"
                    ),
                    features = listOf(
                        "Retrofit + Room + SharedPreferences for fast API fetch + offline access",
                        "Dagger Hilt + MVVM clean architecture setup",
                        "AI-generated chapter audio for an immersive listening experience",
                    )
                ),
            )

            projects.forEach { project ->
                ProjectCard2(
                    title = project.title,
                    desc = project.description,
                    imgPath = project.imageUrl,
                    githubUrl = project.githubUrl ?: "",
                    iconsList = project.icons ?: listOf(),
                    projectTags = project.features ?: listOf()
                )
            }
        }

        // ✅ Grid layout for 2 cards per row
//        Div(
//            attrs = Modifier
//                .display(DisplayStyle.Grid)
//                .gridTemplateColumns {
//                    repeat(2) { size(1.fr) } // exactly 2 columns
//                }
//                .gap(32.px)
//                .maxWidth(1000.px)
//                .margin(top = 20.px)
//                .justifyItems(JustifyItems.Center)
//                .toAttrs()
//        ) {
//            val projects = listOf(
//                Project("NutriSport", "A multiplatform fitness & e-commerce app with Google Sign-In, Firebase & Supabase storage.", "/images/nutri_sport.png","https://github.com/gauravsingh2906/NutritionSports.git", icons = listOf("/tools/Android.png","/tools/compose1.png","/tools/firebase.png","/tools/figma_1.png")),
//                Project("Blinkit Clone", "Grocery delivery app using Kotlin + XML + ViewModel", "/images/quiz_special.png"),
//                Project("QuizTime", "Quiz app powered by Ktor backend & MongoDB", "/images/image_vista.png"),
//                Project("Smart Notes", "AI-powered notes & to-do app with Firebase", "/images/frame.png"),
//                Project("PDF Creator", "Adobe Scan-like app built with Jetpack Compose", "https://via.placeholder.com/300"),
//                Project("Anime World", "2D Anime City builder game in Unreal Engine", "https://via.placeholder.com/300"),
//                Project("Portfolio Site", "This portfolio made with Kobweb & Compose Web", "https://via.placeholder.com/300"),
//                Project("Live Stream App", "Full-screen live streaming app with chat", "https://via.placeholder.com/300")
//            )
//
//            projects.forEach { project ->
//                ProjectCard2(
//                    title = project.title,
//                    desc = project.description,
//                    imgPath = project.imageUrl,
//                    githubUrl = project.githubUrl ?: "",
//                    iconsList = project.icons ?: listOf()
//                )
//            }
//        }
    }
}

// ...

// Replace the Div block with SimpleGrid:


@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun ProjectCard2(
    imgPath: String,
    title: String,
    desc: String,
    githubUrl: String,
    iconsList: List<String>,
    projectTags: List<String>
) {
    var hovered by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .width(420.px)
            .height(580.px)
            .background(
                com.varabyte.kobweb.compose.ui.graphics.Color
                    .rgba(10, 10, 15, 0.7f)
            )
            .borderRadius(18.px)
            .padding(20.px)
            .styleModifier {
                property(
                    "transition",
                    "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.4s ease"
                )
                property(
                    "background",
                    "linear-gradient(145deg, rgba(255,255,255,0.04), rgba(0,0,0,0.25))"
                )
                property("backdrop-filter", "blur(10px)")
                property("border", "1px solid rgba(0,255,255,0.15)")
                property("box-shadow", "0 4px 20px rgba(0,0,0,0.4)")
            }
            .styleModifier {
                if (hovered) {
                    property("transform", "translateY(-10px) scale(1.03)")
                    property("border", "1.5px solid rgba(0,255,255,0.6)")
                    property(
                        "box-shadow",
                        "0 0 25px rgba(0,255,255,0.5), 0 0 50px rgba(0,255,255,0.25)"
                    )
                    property(
                        "animation",
                        "glowPulse 2s ease-in-out infinite"
                    )
                }
            }
//            .boxShadow(
//                offsetX = 0.px,
//                offsetY = if (hovered) 20.px else 8.px,
//                blurRadius = if (hovered) 40.px else 20.px,
//                color = com.varabyte.kobweb.compose.ui.graphics.Color.rgba(
//                    0, 255, 255,
//                    if (hovered) 0.35f else 0.15f
//                )
//            )
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { window.open(githubUrl, "_blank") },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

//        Img(
//            src = imgPath,
//            attrs = Modifier
//                .width(100.percent)
//                .maxHeight(250.px)
//                .objectFit(ObjectFit.Cover)
//                .borderRadius(12.px)
//                .toAttrs()
//        )


        Image(
            src = imgPath,
            description = title,
            modifier = Modifier
                .fillMaxWidth()
                .maxHeight(250.px)
                .borderRadius(14.px)
                .objectFit(ObjectFit.Cover)
                .styleModifier {
                    property("transition", "transform 0.4s ease")
                    if (hovered) {
                        property("transform", "scale(1.05)")
                    }
                }
        )

        SpanText(
            text = title,
            modifier = Modifier
                .fontSize(20.px)
                .fontWeight(FontWeight.Bold)
                .padding(top = 10.px)
                .color(rgb(255, 255, 255))
        )

        SpanText(
            text = desc,
            modifier = Modifier
                .fontSize(14.px)
                .lineHeight(22.px)
                .color(rgba(200, 200, 200,1f))
                .padding(top = 10.px, bottom = 14.px)
                .textAlign(TextAlign.Center)
        )


        Column(
            modifier = Modifier
                .gap(8.px)
                .padding(bottom = 20.px)
                .maxWidth(600.px)
        ) {
            projectTags.forEach { feature ->
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.gap(10.px)
                ) {
                    SpanText(
                        text = "✔",
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(rgb(0, 255, 200))
                    )
                    SpanText(
                        text = feature,
                        modifier = Modifier
                            .fontSize(16.px)
                            .color(rgb(220, 220, 220))
                    )
                }
            }
        }


//        Row(
//            modifier = Modifier
//                .fillMaxWidth(95.percent)
//                .padding(top = 15.px), // Space below the description
//            horizontalArrangement = Arrangement.Center
//            // Consider using a FlowRow from a library if available for wrapping tags
//        ) {
//            projectTags.forEach { tag ->
//                FeatureTag(tag)
//            }
//        }

        Div(
            attrs = Modifier.fillMaxHeight().toAttrs() // Takes all remaining space
        ) {}

        Div(
            attrs = Modifier
                .fillMaxWidth(90.percent) // Line width
                .height(1.px)
                .background(rgba(0, 255, 255, 0.4f)) // Subtle cyan line
                .margin(bottom = 10.px) // Space below the line
                .toAttrs()
        ) {}

        SimpleGrid(
            modifier = Modifier
                .fillMaxWidth(90.percent)
                .justifyItems(JustifyItems.Center), // Increase vertical padding for separation
            numColumns = numColumns(base = 4, sm = 5, md = 6) // Allow for more columns if needed
        ) {
            iconsList.forEach { icon ->
                Image(
                    src = icon,
                    modifier = Modifier
                        .size(26.px) // Slightly smaller icons can help with fit
                        .margin(4.px) // Add margin to separate icons
                        .mixBlendMode(MixBlendMode.Normal)
                )
            }
        }

//        SpanText(
//            text = "View on GitHub 🔗",
//            modifier = Modifier
//                .fontSize(14.px)
//                .color(com.varabyte.kobweb.compose.ui.graphics.Color.rgb(0, 255, 255))
//                .fontWeight(FontWeight.Medium)
//                .styleModifier { property("text-decoration", "underline") }
//        )
    }
}

@Composable
fun FeatureTag(text: String) {
    SpanText(
        text = text,
        modifier = Modifier
            .margin(right = 6.px, bottom = 6.px) // Spacing between tags
            .padding(leftRight = 8.px, topBottom = 4.px)
            .borderRadius(10.px)
            .backgroundColor(rgba(0, 255, 255, 0.1f)) // Light cyan background
            .color(rgb(0, 255, 255)) // Cyan text
            .fontSize(12.px) // Small font size
            .fontWeight(FontWeight.Medium)
    )
}
